import { toast } from 'react-toastify';

export const useNotification = () => {
  const showSuccessNotification = (message) => {
    toast.success(message);
  };

  const showErrorNotification = (message) => {
    toast.error(message);
  };

  return {
    showSuccessNotification,
    showErrorNotification,
  };
};
